// @core/api/endpoints/workflow/create_test_suite.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTestSuiteRequest,
  TestSuiteResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create test suite
 * Creates a test suite grouping multiple test cases. Can block publishing on failure.
 */
export async function CreateTestSuite(
  pipeline_id: string,
  data: CreateTestSuiteRequest,
  options?: RequestOptions
): Promise<TestSuiteResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/test-suites`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<TestSuiteResponse>(requestPath, data, requestOptions);
}
